import type {ComponentProps} from 'react';
import {cn} from '@/lib/utils';

// A table sits on a bordered panel rather than a Card: inside a card the header row blends into
// the card surface. Titles and descriptions go above it as plain heading text.
export function TablePanel({className, ...props}: ComponentProps<'div'>) {
  return (
    <div
      data-slot="table-panel"
      className={cn('border-border bg-card overflow-hidden rounded-lg border', className)}
      {...props}
    />
  );
}
